import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function QRCodeRedirect() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const redirectQRCode = async () => {
      try {
        setLoading(true);
        
        // Get API base URL
        const getApiBaseUrl = () => {
          if (process.env.REACT_APP_API_URL) {
            return process.env.REACT_APP_API_URL;
          }
          const hostname = window.location.hostname;
          const protocol = window.location.protocol;
          const port = window.location.port;
          
          if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'http://localhost:5000/api';
          }
          
          const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
          return `${baseUrl}/api`;
        };

        const apiBaseUrl = getApiBaseUrl();
        
        // Fetch the redirect endpoint
        // Use fetch with redirect: 'manual' to intercept redirects
        const response = await fetch(`${apiBaseUrl}/qrcodes/redirect/${id}`, {
          method: 'GET',
          credentials: 'include',
          redirect: 'manual' // Don't follow redirects automatically
        });

        // Handle redirect response (302, 301, etc.)
        if (response.status >= 300 && response.status < 400) {
          const redirectUrl = response.headers.get('Location');
          if (redirectUrl) {
            // Redirect to the actual URL
            window.location.href = redirectUrl;
            return;
          }
        }

        // Handle HTML content (for TEXT, WIFI, VCARD types)
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.includes('text/html')) {
          const html = await response.text();
          // Replace the entire page content
          document.open();
          document.write(html);
          document.close();
          setLoading(false);
          return;
        }

        // If we get here, something went wrong
        if (!response.ok) {
          const errorText = await response.text();
          setError(errorText || 'Unable to process QR code redirect');
        } else {
          setError('Unable to process QR code redirect');
        }
      } catch (err) {
        console.error('Error redirecting QR code:', err);
        setError('Failed to load QR code. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      redirectQRCode();
    }
  }, [id]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#6b7280'
      }}>
        Redirecting...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#dc2626',
        padding: '20px',
        textAlign: 'center'
      }}>
        <h1>Error</h1>
        <p>{error}</p>
      </div>
    );
  }

  return null;
}

export default QRCodeRedirect;

